/**
 * Extract a YouTube video ID from common URL formats.
 * Returns "" if input is not a valid YouTube URL/ID.
 */
export function extractYoutubeId(input) {
  if (!input) return "";
  const s = String(input).trim();
  // Bare 11-char ID
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  const patterns = [
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|v\/)([A-Za-z0-9_-]{11})/,
    /youtube\.com\/watch\?.*[?&]v=([A-Za-z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = s.match(re);
    if (m) return m[1];
  }
  return "";
}

export function isValidYoutubeUrl(input) {
  return !!extractYoutubeId(input);
}

export function slugifyText(text) {
  return String(text || "")
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s-]/gu, "")
    .replace(/[\s_]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Resolve an image / file URL for `<img src>` or `<a href>`.
 * - Absolute http(s) URLs are passed through unchanged.
 * - Relative /api/uploads/... paths are prefixed with the backend origin.
 * - Anything else is returned as-is.
 */
export function resolveMediaUrl(u) {
  if (!u) return "";
  const s = String(u);
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  if (s.startsWith("/api/uploads/")) return `${base}${s}`;
  return s;
}
